<template>
  <div v-if="buttonOption && Object.keys(buttonOption).length" :class="`btn-trigger-wrap-2 ${buttonOption.Alignment || 'left'}`" :data-index="buttonIndex">
    <div :class="buttonOption.ImageAlignment || 'left'" :style="{ width: `${buttonOption.Width === 'fill' ? '100%' : 'auto'}` }">
      <a :href="getHref" :target="getTarget" :class="getClassName" :style="renderStyles" @click="clickHyperlink">
        <div>
          <i
            v-if="buttonOption.Icon"
            :class="`fa ${getIconExtra(buttonOption.Icon)} fa-${getIconName(buttonOption.Icon)}`"
            :style="{
              color: buttonOption.TextColor || 'inherit',
              fontSize: `${buttonOption.IconSize || 0}px`,
              marginRight: '10px',
            }"
          />
          <div>
            <span
              v-if="buttonOption.Text"
              class="button-text"
              :style="{
                color: buttonOption.TextColor || 'inherit',
                fontWeight: 600,
                fontFamily: buttonOption.FontFamily,
              }"
            >
              {{ buttonOption.Text }}
            </span>
            <span
              v-if="buttonOption.SubText"
              class="button-sub-text"
              :style="{
                color: buttonOption.SubTextColor || 'inherit',
                fontWeight: 400,
                fontFamily: buttonOption.FontFamily,
              }"
            >
              {{ buttonOption.SubText }}
            </span>
          </div>
          <i
            v-if="buttonOption.IconAfter"
            :class="`fa ${getIconExtra(buttonOption.IconAfter)} fa-${getIconName(buttonOption.IconAfter)}`"
            :style="{
              color: buttonOption.TextColor || 'inherit',
              fontSize: `${buttonOption.IconSize || 0}px`,
              marginLeft: '10px',
            }"
          />
        </div>
      </a>
      <template v-if="buttonOption.ShowImage && buttonOption.Image">
        <img v-if="buttonOption.ShowWidth && buttonOption.ShowHeight" :src="buttonOption.Image" :width="buttonOption.ShowWidth" :height="buttonOption.ShowHeight" alt="" />
        <img v-else :src="buttonOption.Image" alt="" />
      </template>
    </div>
  </div>
</template>

<script>
import './Styles/ButtonRenderer2.scss'
import { getFullLink2 } from '@src/helper'
import { getBorderStyleNE } from '@src/editor'
export default {
  props: {
    elementId: { type: [String], default: null, required: true },
    referenceObject: { type: [Object], default: null, required: true },
    referenceType: { type: String, default: null, required: true },
    buttonOption: { type: [Object], default: null, required: true },
    buttonIndex: { type: Number, default: 0 },
    live: { type: Boolean, default: false },
    preview: { type: Boolean, default: false },
    fromLanding: { type: Boolean, default: false }
  },
  computed: {
    link2() {
      if (this.referenceType === 'landing') return this.referenceObject.link2 || ''
      else if (this.referenceObject && this.referenceObject.landing) return this.referenceObject.landing.link2 || ''
      return ''
    },
    styleOptions() {
      return {
        FontSize: this.buttonOption.FontSize,
        MobileFontSize: this.buttonOption.MobileFontSize,
        SubFontSize: this.buttonOption.SubFontSize,
        MobileSubFontSize: this.buttonOption.MobileSubFontSize,
        HoverButtonBackgroundColor: this.buttonOption.HoverButtonBackgroundColor,
        HoverTextColor: this.buttonOption.HoverTextColor,
        HoverSubTextColor: this.buttonOption.HoverSubTextColor || null,
        Border: this.buttonOption.Border,
        HoverBorderColor: this.buttonOption.HoverBorderColor
      }
    },
    styleOptionsInline() {
      return JSON.stringify(this.styleOptions)
    },
    getHref() {
      let href = null
      if (!this.live || this.buttonOption.ActionType !== 'other') {
        return null
      }
      if (this.buttonOption.PageId) {
        if (this.buttonOption.PageId !== '/') {
          href = `${this.link2}/${this.buttonOption.PageId}`
        } else {
          href = this.link2
        }
      } else if (this.buttonOption.WebSectionId) {
        if (this.fromLanding) {
          href = `${this.link2}/#${this.buttonOption.WebSectionId}`
        } else {
          href = `#${this.buttonOption.WebSectionId}`
        }
      } else if (this.buttonOption.CustomLink) {
        href = getFullLink2(this.buttonOption.CustomLink, this.link2, this.fromLanding)
      }
      return href
    },
    getTarget() {
      let target = '_self'
      if (!this.live || this.buttonOption.ActionType !== 'other') {
        return '_self'
      }
      if ((this.buttonOption.PageId || !this.buttonOption.WebSectionId) && this.buttonOption.OpenInNewWindow) {
        target = 'blank'
      }
      return target
    },
    renderStyles() {
      let styles = {
        backgroundColor: this.buttonOption.ButtonBackgroundColor || '#FFFFFF00',
        paddingTop: `${this.buttonOption.PaddingTop || 0}px`,
        paddingBottom: `${this.buttonOption.PaddingBottom || 0}px`,
        paddingLeft: `${this.buttonOption.PaddingLeft || 0}px`,
        paddingRight: `${this.buttonOption.PaddingRight || 0}px`,
        width: `${this.buttonOption.Width === 'fill' ? '100%' : 'auto'}`,
        ...getBorderStyleNE(this.buttonOption)
      }
      if (this.buttonOption.BoxShadow) {
        styles.boxShadow = this.buttonOption.BoxShadow
      }
      if (this.buttonOption.TextShadow) {
        styles.textShadow = this.buttonOption.TextShadow
      }
      return styles
    },
    getClassName() {
      let className = 'btn-trigger'
      if (this.buttonOption.HoverClass) {
        className += ` ${this.buttonOption.HoverClass}`
      }
      if (this.buttonOption.HoverAnimation) {
        className += ` hvr-effect ${this.buttonOption.HoverAnimation}`
      }
      if (this.fromLanding) {
        className += ' renderOnly'
      }
      return className
    }
  },
  watch: {
    styleOptionsInline: {
      handler() {
        this.renderDynamicStyle()
      }
    }
  },
  mounted() {
    this.renderDynamicStyle()
  },
  beforeDestroy() {
    this.removeDynamicStyle()
  },
  methods: {
    removeDynamicStyle() {
      document.getElementById(`button2-style-${this.elementId}-${this.buttonIndex}`) && document.getElementById(`button2-style-${this.elementId}-${this.buttonIndex}`).remove()
    },
    renderDynamicStyle() {
      this.removeDynamicStyle()
      let style = document.createElement('style')
      style.id = `button2-style-${this.elementId}-${this.buttonIndex}`
      let innerHTML = ''
      innerHTML += `#${this.elementId} .btn-trigger-wrap-2[data-index|='${this.buttonIndex}'] .btn-trigger:hover {`
        if (this.styleOptions.HoverButtonBackgroundColor) {
          innerHTML += `background-color: ${this.styleOptions.HoverButtonBackgroundColor} !important;`
        }
        if (this.styleOptions.Border && this.styleOptions.HoverBorderColor) {
          innerHTML += `border-color: ${this.styleOptions.HoverBorderColor} !important;`
        }
      innerHTML += `}`
      if (this.styleOptions.HoverTextColor) {
        innerHTML += `
          #${this.elementId} .btn-trigger-wrap-2[data-index|='${this.buttonIndex}'] .btn-trigger:hover > div > i,
          #${this.elementId} .btn-trigger-wrap-2[data-index|='${this.buttonIndex}'] .btn-trigger:hover > div > div > span:first-child {
            color: ${this.styleOptions.HoverTextColor} !important;
          }
        `
      }
      if (this.styleOptions.HoverSubTextColor) {
        innerHTML += `
          #${this.elementId} .btn-trigger-wrap-2[data-index|='${this.buttonIndex}'] .btn-trigger:hover > div > div > span:nth-child(2) {
            color: ${this.styleOptions.HoverSubTextColor} !important;
          }
        `
      }
      innerHTML += `
        #${this.elementId} .btn-trigger-wrap-2[data-index|='${this.buttonIndex}'] .btn-trigger span.button-text { font-size: ${this.buttonOption.FontSize || 0}px !important; }
        @media screen and (max-width: 1187px) {
          #${this.elementId} .btn-trigger-wrap-2[data-index|='${this.buttonIndex}'] .btn-trigger span.button-text { font-size: ${this.buttonOption.MobileFontSize || 15}px !important; }
        }
        @media screen and (max-width: 767px) {
          #${this.elementId} .btn-trigger-wrap-2[data-index|='${this.buttonIndex}'] .btn-trigger span.button-text { font-size: ${this.buttonOption.MobileFontSize || 15}px !important; }
        }
        .device-mobile #${this.elementId} .btn-trigger-wrap-2[data-index|='${this.buttonIndex}'] .btn-trigger span.button-text{ font-size: ${this.buttonOption.MobileFontSize || 15}px !important; }
        #${this.elementId} .btn-trigger-wrap-2[data-index|='${this.buttonIndex}'] .btn-trigger span.button-sub-text { font-size: ${this.buttonOption.SubFontSize || 0}px !important; }
        @media screen and (max-width: 1187px) {
          #${this.elementId} .btn-trigger-wrap-2[data-index|='${this.buttonIndex}'] .btn-trigger span.button-sub-text { font-size: ${this.buttonOption.MobileSubFontSize || 10}px !important; }
        }
        @media screen and (max-width: 767px) {
          #${this.elementId} .btn-trigger-wrap-2[data-index|='${this.buttonIndex}'] .btn-trigger span.button-sub-text { font-size: ${this.buttonOption.MobileSubFontSize || 10}px !important; }
        }
        .device-mobile #${this.elementId} .btn-trigger-wrap-2[data-index|='${this.buttonIndex}'] .btn-trigger span.button-sub-text{ font-size: ${this.buttonOption.MobileSubFontSize || 10}px !important; }
      `
      style.innerHTML = innerHTML
      document.querySelector('head').append(style)
    },
    clickHyperlink(e) {
      if (!this.live) {
        e.preventDefault()
      }
      if ((this.live || this.preview) && this.buttonOption.ActionType === 'popup') {
        this.$emit('callEvent', { methodName: 'managePopupLoad', target: 'Index2' })
      }
    },
    getIconExtra(string) {
      if (string.split(' ').length > 1 && string.split(' ')[0] && string.split(' ')[1]) {
        return string.split(' ')[0]
      }
      return ''
    },
    getIconName(string) {
      if (string.split(' ').length > 1 && string.split(' ')[0] && string.split(' ')[1]) {
        return string.split(' ')[1]
      }
      return string
    }
  }
}
</script>